<template>
  <div class="bx-content bx-search bx-typo--search">
    <ParagraphTypeSearch
      ref="paragraphTypeSearchRef"
      :brand="brandFromStore"
      title="Suche"
      aria-label="Suche"
      :infinite-scroll="false"
      :initial-search="false"
      :filters-open="filtersOpen"
      :placeholder="'Sendung suchen'"
      :label-search-button="false"
      :is-vod-search="true"
      teaser-group-type="bx-teaser-container--vod"
      :teaser-image-format="'imagePortrait'"
      label="VOD"
      :search="{
        fuzzy: true,
        'searchFieldPaths': [
          'documentData.justWatch.originalTitle^2',
          'documentData.headline',
          'documentData.justWatch.title'
        ],
        'assetType': 'vod',
        'filters': [
          {
            id: 'vodfilters',
            class: 'bx-filters bx-filters--vod',
            items: [
              {
                id: 'provider',
                type: 'multiselect',
                name: 'provider',
                fieldPath: 'documentData.justWatch.offers.provider.technicalName',
                class: 'bx-filters__provider',
                nestedPath: 'documentData.justWatch.offers',
                label: 'Anbieter',
                enableItemFilter: true,
                valueType: 'multiobject',
                valueChoices: providers
              },
              {
                id: 'monetization',
                type: 'multiselect',
                name: 'monetization',
                fieldPath: 'documentData.justWatch.offers.monetizationType',
                nestedPath: 'documentData.justWatch.offers',
                label: 'Angebotsart',
                class: 'bx-filters__monetization',
                valueType: 'multiobject',
                valueChoices: [
                  { id: 'flatrate', value: 'flatrate', label: 'Im Abo enthalten' },
                  { id: 'rent', value: 'rent', label: 'Leihen' },
                  { id: 'buy', value: 'buy', label: 'Kaufen' },
                  { id: 'free', value: 'free', label: 'Kostenlos' }
                ]
              },
              {
                id: 'type',
                type: 'multiselect',
                name: 'type',
                fieldPath: 'documentData.justWatch.objectType',
                label: 'Typ',
                class: 'bx-filters__type',
                valueType: 'multiobject',
                valueChoices: [
                  { id: 'movie', value: 'movie', label: 'Filme' },
                  { id: 'show', value: 'show', label: 'Serien' }
                ]
              },
              {
                id: 'genre',
                type: 'multiselect',
                name: 'genre',
                fieldPath: 'documentData.tmdb.genres.name',
                label: 'Genre',
                enableItemFilter: true,
                class: 'bx-filters__genre',
                valueType: 'multiobject',
                valueChoices: genres
              }
            ]
          }
        ]
      }"
      @search-phrase-changed="searchPhraseChanged">
      <template #searchandfiltertoggle>
        <a name="search-filters"
           class="bx-filter__anchor" />
        <div tabindex="0"
             role="button"
             :aria-label="ariaLabelFilters"
             :aria-expanded="filtersOpen"
             class="bx-filtertoggle"
             @click.prevent="toggleFilters"
             @keyup.enter="toggleFilters">
          <Icon name="filters"
                :class="filtersOpen ? 'icon--active' : 'icon--inactive'" />
          <span>{{ labelFilterToggle() }}</span>
        </div>
      </template>
    </ParagraphTypeSearch>
  </div>
</template>
<script>
import { mapState } from 'pinia'

import { usePageStore } from '../../../../stores/page'
import { ParagraphTypeSearch } from '../../../../components/paragraph-types'
import Icon from '../../../../components/shared/Icon.vue'

export default {
  components: {
    ParagraphTypeSearch, Icon
  },
  data () {
    return {
      filtersOpen: false,
      providers: [
        { id: 'netflix', value: 'netflix', label: 'Netflix' },
        { id: 'amazonprime', value: 'amazonprime', label: 'Amazon Prime Video' },
        { id: 'disneyplus', value: 'disneyplus', label: 'Disney+' },
        { id: 'skyticket', value: 'skyticket', label: 'WOW' },
        { id: 'tvnowde', value: 'tvnowde', label: 'RTL+' },
        { id: 'appletvplus', value: 'appletvplus', label: 'Apple TV+' },
        { id: 'daserstemediathek', value: 'daserstemediathek', label: 'ARD Mediathek' },
        { id: 'zdf', value: 'zdf', label: 'ZDF' },
        { id: 'joynde', value: 'joynde', label: 'Joyn' },
        { id: 'paramountplus', value: 'paramountplus', label: 'Paramount+' },
        { id: 'entertaintv', value: 'entertaintv', label: 'MagentaTV' },
        { id: 'adtv', value: 'adtv', label: 'AD TV' },
        { id: 'akibapass', value: 'akibapass', label: 'Akibapass' },
        { id: 'alleskino', value: 'alleskino', label: 'Alleskino' },
        // { id: 'amazon', value: 'amazon', label: 'Amazon Video' }, // We push this to the query when user selects Amazon Prime Video - check `amazonFuckShit` ParagraphTypeSearch.vue
        { id: 'amazonadrenalin', value: 'amazonadrenalin', label: 'Adrenalin Amazon channel' },
        { id: 'amazonalleskino', value: 'amazonalleskino', label: 'Alleskino Amazon Channel' },
        { id: 'amazonallgoodvibes', value: 'amazonallgoodvibes', label: 'Stingray All good vibes Amazon Channel' },
        { id: 'amazonallstars', value: 'amazonallstars', label: 'Allstars Amazon Channel' },
        { id: 'amazonnflgamepass', value: 'amazonnflgamepass', label: 'Amazon NFL Game Pass' },
        { id: 'amazonsyfyhorror', value: 'amazonsyfyhorror', label: 'Amazon Syfy Horror' },
        { id: 'amazonanimalplanet', value: 'amazonanimalplanet', label: 'Animalplanet Amazon Channel' },
        { id: 'amazonanimedigital', value: 'amazonanimedigital', label: 'Anime Digital Network Amazon Channel' },
        { id: 'amazonaniverse', value: 'amazonaniverse', label: 'Aniverse Amazon Channel' },
        { id: 'amazonardplus', value: 'amazonardplus', label: 'ARD+ Amazon Channel' },
        { id: 'amazonarthaus', value: 'amazonarthaus', label: 'Amazon Arthaus Channel' },
        { id: 'amazonarthousecnma', value: 'amazonarthousecnma', label: 'Arthouse CNMA Amazon Channel' },
        { id: 'amazonasiatic', value: 'amazonasiatic', label: 'ASIATIC Amazon Channel' },
        { id: 'amazonautomotorundsport', value: 'amazonautomotorundsport', label: 'Auto Motor und Sport Amazon Channel' },
        { id: 'amazonaxnblack', value: 'amazonaxnblack', label: 'AXN Black Amazon Channel' },
        { id: 'amazonaxnwhite', value: 'amazonaxnwhite', label: 'AXN White Amazon Channel' },
        { id: 'amazonbattlezone', value: 'amazonbattlezone', label: 'BATTLEZONE Amazon Channel' },
        { id: 'amazonbbcplayer', value: 'amazonbbcplayer', label: 'BBC Player Amazon Channel' },
        { id: 'amazonbloodymovies', value: 'amazonbloodymovies', label: 'Bloody Movies Amazon Channel' },
        { id: 'amazonblutv', value: 'amazonblutv', label: 'BluTV Amazon Channel' },
        { id: 'amazoncinehearts', value: 'amazoncinehearts', label: 'Cinema of Hearts Amazon Channel' },
        { id: 'amazonciplay', value: 'amazonciplay', label: 'Crime+Investigation Play Amazon Channel' },
        { id: 'amazoncirkus', value: 'amazoncirkus', label: 'Cirkus Amazon Channel' },
        { id: 'amazoncomedycentral', value: 'amazoncomedycentral', label: 'Comedy Central+ Amazon Channel' },
        { id: 'amazoncrunchyroll', value: 'amazoncrunchyroll', label: 'Crunchyroll Amazon Channel' },
        { id: 'amazondespiegel', value: 'amazondespiegel', label: 'Spiegel Geschichte Amazon Channel' },
        { id: 'amazondisasterx', value: 'amazondisasterx', label: 'Disaster X Amazon Channel' },
        { id: 'amazondiscoverychannel', value: 'amazondiscoverychannel', label: 'Discovery Amazon Channel' },
        { id: 'amazondiscoveryplus', value: 'amazondiscoveryplus', label: 'Discovery+ Amazon Channel' },
        { id: 'amazondizi', value: 'amazondizi', label: 'Dizi Amazon Channel' },
        { id: 'amazoneentertainment', value: 'amazoneentertainment', label: 'E! Entertainment Amazon Channel' },
        { id: 'amazonfilmlegenden', value: 'amazonfilmlegenden', label: 'Filmlegenden Amazon Channel' },
        { id: 'amazonfilmtastic', value: 'amazonfilmtastic', label: 'Filmtastic Amazon Channel' },
        { id: 'amazonfilmtotal', value: 'amazonfilmtotal', label: 'Film Total Amazon Channel' },
        { id: 'amazonfixandfoxi', value: 'amazonfixandfoxi', label: 'Fix And Foxi Amazon Channel' },
        { id: 'amazonflimmerkistetv', value: 'amazonflimmerkistetv', label: 'FlimmerkisteTV Amazon Channel' },
        { id: 'amazonfounderzone', value: 'amazonfounderzone', label: 'Founderzone Amazon Channel' },
        { id: 'amazonfranatic', value: 'amazonfranatic', label: 'Franatic Amazon Channel' },
        { id: 'amazonfullmoon', value: 'amazonfullmoon', label: 'Full Moon Amazon Channel' },
        { id: 'amazongeotelevision', value: 'amazongeotelevision', label: 'GEO Television Amazon Channel' },
        { id: 'amazongeowild', value: 'amazongeowild', label: 'GEO Wild Amazon Channel' },
        { id: 'amazongoodmovies', value: 'amazongoodmovies', label: 'Good Movies Amazon Channel' },
        { id: 'amazongrjngo', value: 'amazongrjngo', label: 'GRJNGO Amazon Channel' },
        { id: 'amazongutelaune', value: 'amazongutelaune', label: 'Gute Laune TV Amazon Channel' },
        { id: 'amazonhayu', value: 'amazonhayu', label: 'Hayu Amazon Channel' },
        { id: 'amazonhistorama', value: 'amazonhistorama', label: 'Historama Amazon Channel' },
        { id: 'amazonhistory', value: 'amazonhistory', label: 'HistoryPlay Amazon Channel' },
        { id: 'amazonhomeofhorror', value: 'amazonhomeofhorror', label: 'Home of Horror Amazon Channel' },
        { id: 'amazonhorsecountry', value: 'amazonhorsecountry', label: 'H & C TV Amazon Channel' },
        { id: 'amazonimdbtv', value: 'amazonimdbtv', label: 'Freevee' },
        { id: 'amazonkabeleins', value: 'amazonkabeleins', label: 'Kabel Eins Classics Amazon Channel' },
        { id: 'amazonkinderwelt', value: 'amazonkinderwelt', label: 'Kinderwelt Amazon Channel' },
        { id: 'amazonkixi', value: 'amazonkixi', label: 'Kixi Select Amazon Channel' },
        { id: 'amazonkrimi', value: 'amazonkrimi', label: 'ZDF Krimi Amazon Channel' },
        { id: 'amazonlivingrtl', value: 'amazonlivingrtl', label: 'RTL Living Amazon Channel' },
        { id: 'amazonloveandpassion', value: 'amazonloveandpassion', label: 'Love and Passion Amazon Channel' },
        { id: 'amazonmgmplus', value: 'amazonmgmplus', label: 'MGM+ Amazon Channel' },
        { id: 'amazonmoconomy', value: 'amazonmoconomy', label: 'Moconomy Amazon Channel' },
        { id: 'amazonmotorvision', value: 'amazonmotorvision', label: 'Motorvision TV Amazon Channel' },
        { id: 'amazonmoviecult', value: 'amazonmoviecult', label: 'Moviecult Amazon Channel' },
        { id: 'amazonmoviedome', value: 'amazonmoviedome', label: 'Moviedome+ Amazon Channel' },
        { id: 'amazonmtvplus', value: 'amazonmtvplus', label: 'MTV+ Amazon Channel' },
        { id: 'amazonmubi', value: 'amazonmubi', label: 'MUBI Amazon Channel' },
        { id: 'amazonnetzkinoselect', value: 'amazonnetzkinoselect', label: 'Netzkino Select Amazon Channel' },
        { id: 'amazonnoggin', value: 'amazonnoggin', label: 'Noggin Amazon Channel' },
        { id: 'amazonokidoki', value: 'amazonokidoki', label: 'Okidoki Amazon Channel' },
        { id: 'amazonouttv', value: 'amazonouttv', label: 'OUTtv Amazon Channel' },
        { id: 'amazonparamountplus', value: 'amazonparamountplus', label: 'Paramount+ Amazon Channel' },
        { id: 'amazonprimevideowithads', value: 'amazonprimevideowithads', label: 'Amazon Prime Video with Ads' },
        { id: 'amazonprosieben', value: 'amazonprosieben', label: 'Seven Entertainment Amazon Channel' },
        { id: 'amazonprosiebenfun', value: 'amazonprosiebenfun', label: 'ProSieben Fun Amazon Channel' },
        { id: 'amazonqelloconcerts', value: 'amazonqelloconcerts', label: 'Qello Concerts by Stingray Amazon Channel' },
        { id: 'amazonqueercinema', value: 'amazonqueercinema', label: 'Queer Cinemab Amazon Channel' },
        { id: 'amazonrealeyz', value: 'amazonrealeyz', label: 'Sooner Amazon Channel' },
        { id: 'amazonredlightcinema', value: 'amazonredlightcinema', label: 'Redlight Cinema Amazon Channel' },
        { id: 'amazonromancetv', value: 'amazonromancetv', label: 'Fernsehen mit Herz Amazon Channel' },
        { id: 'amazonrtlcrime', value: 'amazonrtlcrime', label: 'RTL Crime Amazon Channel' },
        { id: 'amazonrtlpassion', value: 'amazonrtlpassion', label: 'RTL Passion Amazon Channel' },
        { id: 'amazonsat1emotions', value: 'amazonsat1emotions', label: 'Sat.1 emotions Amazon Channel' },
        { id: 'amazonscificinemade', value: 'amazonscificinemade', label: 'Galactic Stream Amazon Channel' },
        { id: 'amazonsilverline', value: 'amazonsilverline', label: 'Silverline Amazon Channel' },
        { id: 'amazonsonyentv', value: 'amazonsonyentv', label: 'Sony Amazon Channel' },
        { id: 'amazonsportdigital', value: 'amazonsportdigital', label: 'Sportdigital Amazon Channel' },
        { id: 'amazonstingrayclassica', value: 'amazonstingrayclassica', label: 'Stingray Classica Amazon Channel' },
        { id: 'amazonstingraydjazz', value: 'amazonstingraydjazz', label: 'Stingray Djazz Amazon Channel' },
        { id: 'amazonstudiocanalpresentsallstars', value: 'amazonstudiocanalpresentsallstars', label: 'Studiocanal Presents ALLSTARS Amazon Channel' },
        { id: 'amazonstudiocanalpresentsmoviecult', value: 'amazonstudiocanalpresentsmoviecult', label: 'Studiocanal Presents MOVIECULT Amazon Channel' },
        { id: 'amazonsuperfresh', value: 'amazonsuperfresh', label: 'Superfresh Amazon Channel' },
        { id: 'amazonterrax', value: 'amazonterrax', label: 'Terra X Amazon Channel' },
        { id: 'amazonthrillbox', value: 'amazonthrillbox', label: 'Thrillbox Amazon Channel' },
        { id: 'amazonturkonvideo', value: 'amazonturkonvideo', label: 'Turk On Video Amazon Channel' },
        { id: 'amazontv1000', value: 'amazontv1000', label: 'TV1000 Russian Kino Amazon Channel' },
        { id: 'amazonviaplay', value: 'amazonviaplay', label: 'Viaplay Amazon Channel' },
        { id: 'amazonwaidwerk', value: 'amazonwaidwerk', label: 'Waidwerk Amazon Channel' },
        { id: 'amazonwatch4plus', value: 'amazonwatch4plus', label: 'Watch4+ Amazon Channel' },
        { id: 'amazonwildwest', value: 'amazonwildwest', label: 'Wild West Amazon Channel' },
        { id: 'amazonxplore', value: 'amazonxplore', label: 'Bergblick Amazon Channel' },
        { id: 'amazonzdfherzkino', value: 'amazonzdfherzkino', label: 'ZDF Herzkino Amazon Channel' },
        { id: 'amazonzdfselect', value: 'amazonzdfselect', label: 'ZDF Select Amazon Channel' },
        { id: 'amazonzdftivi', value: 'amazonzdftivi', label: 'ZDFtivi Amazon channel' },
        { id: 'animedigitalnetwork', value: 'animedigitalnetwork', label: 'Animation Digital Network' },
        { id: 'appletvardplus', value: 'appletvardplus', label: 'ARD+ Apple TV channel' },
        { id: 'appletvarthaus', value: 'appletvarthaus', label: 'Arthaus+ Apple TV channel' },
        { id: 'appletvciplay', value: 'appletvciplay', label: 'Crime+Investigation Play Apple TV Channel' },
        { id: 'appletvparamountplus', value: 'appletvparamountplus', label: 'Paramount+ Apple TV Channel' },
        { id: 'ardplus', value: 'ardplus', label: 'ARD+' },
        { id: 'arte', value: 'arte', label: 'Arte' },
        { id: 'arthausplus', value: 'arthausplus', label: 'Arthaus+' },
        { id: 'arthousecnma', value: 'arthousecnma', label: 'ArthouseCNMA' },
        { id: 'avaberlin', value: 'avaberlin', label: 'AVA VOBB' },
        { id: 'avanrw', value: 'avanrw', label: 'AVA HBZ' },
        { id: 'behindthetree', value: 'behindthetree', label: 'Behind the Tree' },
        { id: 'benficatv', value: 'benficatv', label: 'Benfica TV' },
        { id: 'blasttvesports', value: 'blasttvesports', label: 'BLAST TV Esports' },
        { id: 'blutv', value: 'blutv', label: 'bluTV' },
        { id: 'broadwayhd', value: 'broadwayhd', label: 'BroadwayHD' },
        { id: 'cineplexde', value: 'cineplexde', label: 'Cineplex' },
        { id: 'cinestar', value: 'cinestar', label: 'CineStar' },
        { id: 'crunchyroll', value: 'crunchyroll', label: 'Crunchyroll' },
        { id: 'cultpix', value: 'cultpix', label: 'Cultpix' },
        { id: 'curiositystream', value: 'curiositystream', label: 'Curiosity Stream' },
        { id: 'dafilms', value: 'dafilms', label: 'DocAlliance Films' },
        { id: 'dazn', value: 'dazn', label: 'DAZN' },
        { id: 'df1', value: 'df1', label: 'DF1' },
        { id: 'dekkoo', value: 'dekkoo', label: 'Dekkoo' },
        { id: 'docsville', value: 'docsville', label: 'Docsville' },
        { id: 'dynmedia', value: 'dynmedia', label: 'Dyn Media' },
        { id: 'discoverypluseurope', value: 'discoverypluseurope', label: 'Discovery+' },
        { id: 'epcrtv', value: 'epcrtv', label: 'EPCR TV' },
        { id: 'eurosport', value: 'eurosport', label: 'Eurosport' },
        { id: 'eventive', value: 'eventive', label: 'Eventive' },
        { id: 'f1tv', value: 'f1tv', label: 'F1 TV' },
        { id: 'fanatiz', value: 'fanatiz', label: 'Fanatiz' },
        { id: 'fifaplus', value: 'fifaplus', label: 'FIFA+' },
        { id: 'filmbox', value: 'filmbox', label: 'FilmBox' },
        { id: 'filmspiegel', value: 'filmspiegel', label: 'Filmspiegel' },
        { id: 'filmbox', value: 'filmbox', label: 'FilmBox+' },
        { id: 'filmfriend', value: 'filmfriend', label: 'filmfriend' },
        { id: 'filmingo', value: 'filmingo', label: 'filmingo' },
        { id: 'filmtastic', value: 'filmtastic', label: 'Filmtastic' },
        { id: 'filmzie', value: 'filmzie', label: 'Filmzie' },
        { id: 'freenet', value: 'freenet', label: 'Freenet meinVOD' },
        { id: 'funk', value: 'funk', label: 'Funk' },
        { id: 'gameflowtv', value: 'gameflowtv', label: 'Gameflow TV' },
        { id: 'guidedoc', value: 'guidedoc', label: 'GuideDoc' },
        { id: 'hayu', value: 'hayu', label: 'Hayu' },
        { id: 'hoichoi', value: 'hoichoi', label: 'Hoichoi' },
        { id: 'homeofhorror', value: 'homeofhorror', label: 'Home of Horror' },
        { id: 'itunes', value: 'itunes', label: 'Apple TV' },
        { id: 'joyndeplus', value: 'joyndeplus', label: 'Joyn+' },
        { id: 'justwatchplexchannel', value: 'justwatchplexchannel', label: 'Plex Channel' },
        { id: 'justwatchtv', value: 'justwatchtv', label: 'JustWatchTV' },
        { id: 'kika', value: 'kika', label: 'KiKA' },
        { id: 'kinoondemand', value: 'kinoondemand', label: 'Kino on Demand' },
        { id: 'kixi', value: 'kixi', label: 'Kixi' },
        { id: 'lacinetek', value: 'lacinetek', label: 'LaCinetek' },
        { id: 'magellantv', value: 'magellantv', label: 'Magellan TV' },
        { id: 'maxdomestore', value: 'maxdomestore', label: 'Maxdome Store' },
        { id: 'microsoft', value: 'microsoft', label: 'Microsoft Store' },
        { id: 'moviesaints', value: 'moviesaints', label: 'MovieSaints' },
        { id: 'mubi', value: 'mubi', label: 'MUBI' },
        { id: 'mlbtv', value: 'mlbtv', label: 'MLB TV' },
        { id: 'mlsseasonpass', value: 'mlsseasonpass', label: 'MLS Season Pass' },
        { id: 'morethansportstv', value: 'morethansportstv', label: 'More Than Sports TV' },
        { id: 'nbaleaguepass', value: 'nbaleaguepass', label: 'NBA League Pass' },
        { id: 'nflgamepass', value: 'nflgamepass', label: 'NFL Game Pass' },
        { id: 'nflgpyoutube', value: 'nflgpyoutube', label: 'NFL Game Pass YouTube' },
        { id: 'nhltv', value: 'nhltv', label: 'NHL TV' },
        { id: 'nwslsoccercom', value: 'nwslsoccercom', label: 'NWSL Soccer' },
        { id: 'netflixbasicwithads', value: 'netflixbasicwithads', label: 'Netflix basic with Ads' },
        { id: 'netflixkids', value: 'netflixkids', label: 'Netflix Kids' },
        { id: 'netzkino', value: 'netzkino', label: 'Netzkino' },
        { id: 'onefootball', value: 'onefootball', label: 'OneFootball' },
        { id: 'paramountpictures', value: 'paramountpictures', label: 'Paramount Pictures' },
        { id: 'plaionpictures', value: 'plaionpictures', label: 'Plaion Pictures' },
        { id: 'play', value: 'play', label: 'Google Play Movies' },
        { id: 'plex', value: 'plex', label: 'Plex' },
        { id: 'plutotv', value: 'plutotv', label: 'Pluto TV' },
        { id: 'popcorntimes', value: 'popcorntimes', label: 'Popcorntimes' },
        { id: 'prtv', value: 'prtv', label: 'PR TV' },
        { id: 'prosiebenmaxx', value: 'prosiebenmaxx', label: 'ProSieben Maxx' },
        { id: 'ran', value: 'ran', label: 'ran' },
        { id: 'sat1', value: 'sat1', label: 'Sat.1' },
        { id: 'servustvon', value: 'servustvon', label: 'ServusTV On' },
        { id: 'shahidvip', value: 'shahidvip', label: 'Shahid VIP' },
        { id: 'skygo', value: 'skygo', label: 'Sky Go' },
        { id: 'skystore', value: 'skystore', label: 'Sky Store' },
        { id: 'skysport', value: 'skysport', label: 'Sky Sport' },
        { id: 'sportbildde', value: 'sportbildde', label: 'Sport Bild' },
        { id: 'sportdeutschland', value: 'sportdeutschland', label: 'Sportdeutschland' },
        { id: 'sportdigital', value: 'sportdigital', label: 'Sportdigital' },
        { id: 'sportone', value: 'sportone', label: 'Sport1' },
        { id: 'sportoneextra', value: 'sportoneextra', label: 'Sport1 Extra' },
        { id: 'sportoneplus', value: 'sportoneplus', label: 'Sport1+' },
        { id: 'sportschau', value: 'sportschau', label: 'Sportschau' },
        { id: 'spamflix', value: 'spamflix', label: 'Spamflix' },
        { id: 'sooner', value: 'sooner', label: 'Sooner' },
        { id: 'southpark', value: 'southpark', label: 'South Park' },
        { id: 'sunnxt', value: 'sunnxt', label: 'Sun Nxt' },
        { id: 'takflix', value: 'takflix', label: 'Takflix' },
        { id: 'tele5', value: 'tele5', label: 'TELE 5' },
        { id: 'tennischannel', value: 'tennischannel', label: 'Tennis Channel' },
        { id: 'tennistv', value: 'tennistv', label: 'Tennis TV' },
        { id: 'threesatde', value: 'threesatde', label: '3sat' },
        { id: 'toggo', value: 'toggo', label: 'Toggo' },
        { id: 'twitch', value: 'twitch', label: 'Twitch' },
        { id: 'truestory', value: 'truestory', label: 'True Story' },
        { id: 'ucikinowelt', value: 'ucikinowelt', label: 'UCI Kinowelt' },
        { id: 'urctv', value: 'urctv', label: 'URC TV' },
        { id: 'verleihshop', value: 'verleihshop', label: 'Verleihshop' },
        { id: 'videobuster', value: 'videobuster', label: 'Videobuster' },
        { id: 'videoload', value: 'videoload', label: 'Videoload' },
        { id: 'viki', value: 'viki', label: 'Rakuten Viki' },
        { id: 'wedotv', value: 'wedotv', label: 'Wedo TV' },
        { id: 'wowpresentsplus', value: 'wowpresentsplus', label: 'WOW Presents+' },
        { id: 'wuaki', value: 'wuaki', label: 'Rakuten TV' },
        { id: 'yorckondemand', value: 'yorckondemand', label: 'Yorck on Demand' },
        { id: 'youtube', value: 'youtube', label: 'YouTube' },
        { id: 'youtubered', value: 'youtubered', label: 'YouTube Premium' },
        { id: 'youtubesports', value: 'youtubesports', label: 'YouTube Sports' }
      ],
      genres: [
        { id: 'abenteuer', value: 'Abenteuer', label: 'Abenteuer' },
        { id: 'action', value: 'Action', label: 'Action' },
        { id: 'action_adventure', value: 'Action & Adventure', label: 'Action & Adventure' },
        { id: 'animation', value: 'Animation', label: 'Animation' },
        { id: 'dokumentarfilm', value: 'Dokumentarfilm', label: 'Dokumentarfilm' },
        { id: 'drama', value: 'Drama', label: 'Drama' },
        { id: 'familie', value: 'Familie', label: 'Familie' },
        { id: 'fantasy', value: 'Fantasy', label: 'Fantasy' },
        { id: 'historie', value: 'Historie', label: 'Historie' },
        { id: 'horror', value: 'Horror', label: 'Horror' },
        { id: 'kids', value: 'Kids', label: 'Kids' },
        { id: 'komoedie', value: 'Komödie', label: 'Komödie' },
        { id: 'kriegsfilm', value: 'Kriegsfilm', label: 'Kriegsfilm' },
        { id: 'krimi', value: 'Krimi', label: 'Krimi' },
        { id: 'liebesfilm', value: 'Liebesfilm', label: 'Liebesfilm' },
        { id: 'musical', value: 'Musical', label: 'Musical' },
        { id: 'musik', value: 'Musik', label: 'Musik' },
        { id: 'mystery', value: 'Mystery', label: 'Mystery' },
        { id: 'news', value: 'News', label: 'Nachrichten' },
        { id: 'reality', value: 'Reality', label: 'Reality' },
        { id: 'sci_fi_fantasy', value: 'Sci-Fi & Fantasy', label: 'Sci-Fi & Fantasy' },
        { id: 'science_fiction', value: 'Science Fiction', label: 'Science Fiction' },
        { id: 'soap', value: 'Soap', label: 'Soap' },
        { id: 'tv_film', value: 'TV-Film', label: 'TV-Film' },
        { id: 'talk', value: 'Talk', label: 'Talk' },
        { id: 'thriller', value: 'Thriller', label: 'Thriller' },
        { id: 'war_politics', value: 'War & Politics', label: 'Krieg & Politik' },
        { id: 'western', value: 'Western', label: 'Western' }
      ]
    }
  },
  computed: {
    ...mapState(usePageStore, ['brandFromStore']),
    ariaLabelFilters () {
      return this.filtersOpen ? 'Filter schliessen' : 'Filter öffnen'
    }
  },
  mounted () {
    const searchFiltersOpen = window.localStorage.getItem('searchFiltersOpen')
    if (searchFiltersOpen !== null) {
      this.filtersOpen = searchFiltersOpen === 'true'
    } else if (this.$refs.paragraphTypeSearchRef.searchPhrase.length === 0) {
      this.toggleFilters()
    }
    // Click outside to close multiselects - only one multiselect can be open at a time
    // while we are using multiselects only for TVM, we add the event listener here
    document.addEventListener('click', this.closeMultiselects)
  },
  beforeUnmount () {
    document.removeEventListener('click', this.closeMultiselects)
  },
  methods: {
    toggleFilters () {
      this.filtersOpen = !this.filtersOpen
      window.localStorage.setItem('searchFiltersOpen', this.filtersOpen)
    },
    labelFilterToggle () {
      return this.filtersOpen ? 'Filter auswählen' : 'Filter anzeigen'
    },
    searchPhraseChanged (searchPhrase) {
      if (searchPhrase.length === 0) {
        this.filtersOpen = true
        this.labelFilterToggle()
      }
    },
    closeMultiselects (event) {
      const allMultiselects = document.querySelectorAll('.bx-multiselect')
      let clickedInside = false

      allMultiselects.forEach(ms => {
        if (ms.contains(event.target)) {
          clickedInside = true
          // all other multiselects should be closed, except the clicked one
          allMultiselects.forEach(other => {
            if (other !== ms) other.classList.remove('bx-js-open')
          })
        }
      })
      // if click was outside, close all multiselects
      if (!clickedInside) {
        allMultiselects.forEach(ms => ms.classList.remove('bx-js-open'))
      }
    }
  }
}
</script>
